<template>
  <q-page class="flex column  page-layout">
    <div class="grid-container-2-columns-stacked">
      <section class="grid-container-2-columns-stacked__item--full-row">
        <q-card flat class="filter-card">
          <q-card-section class="filter-card__section">
            <TheSiteSelector v-on:updateFilter="handleFilterUpdate($event)" />
          </q-card-section>
        </q-card>
      </section>

      <section class="grid-container-2-columns-stacked__item--full-row">
        <q-card flat class="table-card">
          <q-card-section class="table-card__section">
            <TheKPIList
              :filter="filterOption"
              dataset="LiveDashboard_Top5KPIs_Hourly"
            />
          </q-card-section>
        </q-card>
      </section>

      <section class="grid-container-2-columns-stacked__item">
        <q-card flat class="d3-card">
          <q-card-section class="d3-card__section">
            <LiveDashboardChart
              :filter="filterOption"
              title="5 Min Interval Stake, Wins and Revenue"
              dataset="LiveDashboard_WagerWinsGGRPer5MinutesLast2Hours"
              height="600"
            />
          </q-card-section>
        </q-card>
      </section>
      <section class="grid-container-2-columns-stacked__item-2-rows">
        <q-card flat class="table-card">
          <q-card-section class="table-card__section">
            <TheTodayStatisticsTable
              :filter="filterOption"
              title="Todays Live Data vs. 3 Month Average"
              dataset="TodayStatistics_TodayVsThreeMonthAverage"
              :timer="180000"
            />
          </q-card-section>
        </q-card>
      </section>
    </div>
  </q-page>
</template>

<script>
import TheKPIList from "@/components/other/TheKPIList.vue";
import TheSiteSelector from "@/components/filters/TheSiteSelector.vue";
import LiveDashboardChart from "@/components/charts/LiveDashboardChart.vue";
import TheTodayStatisticsTable from "@/components/tables/today-statistics/TheTodayStatisticsTable.vue";

export default {
  name: "TodayStatistics",
  data() {
    return {
      filterOption: {
        siteId: 0,
        networkId: 0,
        operatorId: 0,
      },

      selectedPlayerSite: "",
    };
  },
  components: {
    LiveDashboardChart,
    TheSiteSelector,
    TheKPIList,
    TheTodayStatisticsTable,
  },

  methods: {
    handleFilterUpdate: function(filterOption) {
      this.filterOption = filterOption;
    },
  },
};
</script>
